import React from 'react';
import { useImageLoading } from './hooks/useImageLoading';
import { HERO_GRAPHIC_URL, HERO_GRAPHIC_ALT } from './constants/images';
import { HeroImage } from './styles/HeroImage';

export default function HeroGraphic() {
  const { handleLoad, isLoaded } = useImageLoading();

  return (
    <div className="relative w-full h-full flex items-center">
      <div className="relative z-10 w-full flex items-center">
        <HeroImage
          src={HERO_GRAPHIC_URL}
          alt={HERO_GRAPHIC_ALT}
          isLoaded={isLoaded}
          onLoad={handleLoad}
        />
      </div>
      
      {/* Decorative gradients */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary/10 to-secondary/10 rounded-3xl blur-2xl opacity-30" />
      <div className="absolute inset-0 bg-gradient-to-b from-primary/5 to-secondary/5 rounded-3xl blur-xl opacity-40" />
    </div>
  );
}